import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import {
  DeliveryStatus,
  DepositStatus,
  PaymentMethod,
  PurchaseStatus,
  YesNo,
} from 'interfaces';

export type Rental = {
  rental_id?: number; // 렌탈 idx
  shop_information_id?: number;
  order_id?: number;
  coupon_id?: number; // 쿠폰 idx
  user_id?: number; // 유저 idx
  delivery_address?: { [key: string]: string | number }; // 배송지
  rental_option?: { [key: string]: Record<string, any> }; // 렌탈 옵션
  rental_start_date?: number; // 렌탈 시작일
  rental_end_date?: number; // 렌탈 종료일
  rental_price?: number; // 렌탈 금액
  invoice_number?: string; // 송장번호
  delivery_status?: (typeof DeliveryStatus)[keyof typeof DeliveryStatus]; // 택배 상태
  product?: { [key: string]: Record<string, any> }; // 상품 원본
  payment_date?: number; // 결제일
  deposit_status?: (typeof DepositStatus)[keyof typeof DepositStatus]; // 입금상태
  purchase_status?: (typeof PurchaseStatus)[keyof typeof PurchaseStatus]; // 구매상태
  payment_method?: (typeof PaymentMethod)[keyof typeof PaymentMethod]; // 결제수단
  is_present?: (typeof YesNo)[keyof typeof YesNo]; // 선물 여부
  group_id?: string; // 그룹 idx
  num?: number; // 수량
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Rental
   * --
   */
  getRentals: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_RENTAL, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Rental
   * --
   */
  getRental: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_RENTAL, { rental_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Rental
   * --
   */
  createRental: async (body: Rental) => {
    try {
      const res = await $http.post(APIConstant.CREATE_RENTAL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Rental
   * --
   */
  updateRental: async (body: Rental) => {
    try {
      const { rental_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_RENTAL, {
        rental_id: rental_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Rental
   * --
   */
  deleteRental: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_RENTAL, {
        rental_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Bulk Rental
   * --
   */
  bulkCreateRental: async (body: Rental[]) => {
    try {
      const res = await $http.post(APIConstant.BULK_CREATE_RENTAL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Bulk Rental
   * --
   */
  bulkUpdateRental: async (body: Rental[]) => {
    try {
      const res = await $http.put(APIConstant.BULK_UPDATE_RENTAL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Bulk Rental
   * --
   */
  bulkDeleteRental: async (body: Rental[]) => {
    try {
      const res = await $http.delete(APIConstant.BULK_DELETE_RENTAL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Status Rental
   * --
   */
  updateStatusRental: async (body: Rental) => {
    try {
      const { rental_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_STATUS_RENTAL, {
        rental_id: rental_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Confirm Rental
   * --
   */
  updateConfirmRental: async (body: Rental) => {
    try {
      const { rental_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_CONFIRM_RENTAL, {
        rental_id: rental_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
